import React from 'react';
import MyAvatar from 'components/my-avatar';
const App = () => {
  return (
    <div className="flex flex-col gap-4 justify-center items-center h-screen m-auto">
      <MyAvatar />
    </div>
  );
};
export default App;
